import { createContext, memo, useContext } from 'react';
const EditModeContext = createContext<{
  isEditMode: boolean;
  onEditModeChange: (isEditMode: boolean) => void;
}>({
  isEditMode: false,
  onEditModeChange: () => {}
});
export const EditModeProvider = memo(({
  children,
  isEditMode,
  onEditModeChange
}: {
  children: React.ReactNode;
  isEditMode: boolean;
  onEditModeChange: (isEditMode: boolean) => void;
}) => {
  return <EditModeContext.Provider value={{
    isEditMode,
    onEditModeChange
  }}>
        {children}
      </EditModeContext.Provider>;
}, (prevProps, nextProps) => {
  return prevProps.isEditMode === nextProps.isEditMode;
});
export const useEditMode = () => {
  return useContext(EditModeContext);
};